// eslint-disable-next-line import/prefer-default-export
export const COMMUNITYUSER_REQUEST_SELECTOR_KEY = 'chats/requests';
